export const GET_GALLERY_ITEMS = "GET_GALLERY_ITEMS";
export const GET_GALLERY_ITEMS_LOADING = "GET_GALLERY_ITEMS_LOADING";

export const GET_SINGLE_GALLERY_ITEM = "GET_SINGLE_GALLERY_ITEM";
export const GET_SINGLE_GALLERY_ITEM_LOADING =
  "GET_SINGLE_GALLERY_ITEM_LOADING";
